import { render, staticRenderFns } from "./Listagem-preparar-certificado-admin.vue?vue&type=template&id=4b97dc3b&"
import script from "./Listagem-preparar-certificado-admin.vue?vue&type=script&lang=js&"
export * from "./Listagem-preparar-certificado-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports